import { api } from './client'
import type { ApiResponse, ContactInfo } from '@/services/types'

export const siteApi = {
  getContact: () => api.post<ApiResponse<ContactInfo>>('/site/contact', {}),
}
